export default __webpack_public_path__ + "static/media/warning--railroad-intersection--g9.e91cfdd5.png";